export function Text(author, title, lines){
  this.author = author || [];
  this.title = title || [];
  this.lines = lines || [];
}

export function Lesson(lessonID, component, lessonData, infoData){
  this.lessonID = lessonID || [];
  this.component = component || [];
  this.lessonData = lessonData || [];
  this.infoData = infoData || [];
}

export function Info(infoID, buttons, heading, list, listHeading, paragraphs){
  this.infoID = infoID || [];
  this.buttons = buttons || [];
  this.heading = heading || [];
  this.list = list || [];
  this.listHeading = listHeading || [];
  this.paragraphs = paragraphs || [];
}



// WEBPACK FOOTER //
// ./src/reducers/reducer_helper.js